import {put, delay} from 'redux-saga/effects';
import {moment} from 'helpers';

export function* sessionTime() {
  while (true) {
    const now = moment();
    const nextMinute = now.clone().add(1, 'minute').startOf('minute');
    yield delay(nextMinute.diff(now, 'ms'));
    yield put({ type: 'SESSION_TIME_TICK' });
  }
}
